export default "__VITE_ASSET__D$SPO4kK__"